import { StageInterface } from '@vendasta/sales-opportunities';

export function compareStages(stageA: StageInterface, stageB: StageInterface): number {
  if (stageA.probability > stageB.probability) {
    return 1;
  }
  if (stageA.probability < stageB.probability) {
    return -1;
  }
  return 0;
}
